import styled from 'styled-components';

export const StyledMedicineSafetyIndicators = styled.div`
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   grid-template-rows: repeat(2, 1fr);
`;
StyledMedicineSafetyIndicators.displayName = 'StyledMedicineSafetyIndicators';
